function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsonant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#28f533",
    r: 256,
    "data-original": "#ff3333",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m505.487 313.621-160.093-160.092c-18.024-21.509-109.532-11.837-109.532-11.837-81.737 34.801-55.044 229.087-55.044 229.087l134.338 134.338c94.384-22.329 168.57-96.894 190.331-191.496z",
    fill: "#40c600",
    "data-original": "#c60000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m310.567 308.76c-5.573 16.996-21.595 29.301-40.428 29.301h-26.349c-23.459 0-42.551-19.092-42.551-42.551v-79.019c0-23.469 19.092-42.551 42.551-42.551h26.349c18.832 0 34.855 12.304 40.428 29.291h56.858c-6.481-47.892-47.641-84.926-97.286-84.926h-26.349c-54.141 0-98.185 44.044-98.185 98.185v79.019c0 54.141 44.044 98.185 98.185 98.185h26.349c49.644 0 90.804-37.034 97.295-84.935h-56.867z",
    fill: "#f8fffb",
    "data-original": "#f8fffb",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m310.57 203.23h56.86c-6.49-47.89-47.65-84.92-97.29-84.92h-14.14v55.63h14.14c18.83 0 34.85 12.3 40.43 29.29zm-40.43 134.83h-14.14v55.63h14.14c49.64 0 90.8-37.03 97.29-84.93h-56.86c-5.58 17-21.6 29.3-40.43 29.3z",
    fill: "#d8d8d8",
    "data-original": "#d8d8d8",
    style: {},
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsonant);
export default __webpack_public_path__ + "static/media/consonant.11a8a9bb71c81ba731e2c6e94054b27c.svg";
export { ForwardRef as ReactComponent };